<template>
  <div>
    <div v-show="scanArticle">
      <video
        ref="video"
        style="width: 100%; height: auto"
      />
    </div>
    <button
      v-if="scanArticle"
      class="primary"
      @click="removeScanner"
    >
      {{ $t('RemoveScanner') }}
    </button>
    <div v-if="!scanArticle">
      <div style="display:flex;justify-content:space-between;margin-top:10px;">
        <div>
          <div
            class="toolbar__row"
          >
            <div
              class="search-filter"
            >
              <b-icon-search />
              <input
                v-model="searchValue"
                type="text"
                autocomplete="off"
                name="search-box"
                :placeholder="$t(toggleSearch)"
                @keydown.down.prevent="arrowDown"
                @keydown.up.prevent="arrowUp"
                @keydown.enter.prevent="selectHighlighted"
              >
              <b-icon-x-circle
                class="search-filter__clear"
                :class="{ 'search-filter__clear--active': searchValue !== '' }"
                @click="searchValue = ''"
              />
              <b-form-select
                v-model="toggleSearch"
                :options="searchFilterOptions"
              />
              <LoadingWrapperSpinner
                ref="scrollContainer"
                class="search-filter__options"
              >
                <div
                  v-for="(result, index) in filteredResults"
                  :key="index"
                  ref="options"
                  :class="{ 'is-active': index === arrowCounter }"
                  class="search-filter__option"
                  @click="selectResult(result)"
                >
                  {{ displayResult(result) }}
                </div>
              </LoadingWrapperSpinner>
            </div>
          </div>
        </div>
        <div style="display:flex; gap:10px;">
          <button
            class="primary"
            @click="addCustomArticle"
          >
            <img
              src="@/assets/images/plus-circle.svg"
              alt="plus-icon"
            >
            {{ $t('AddCustomArticle') }}
          </button>
          <button
            v-if="!scanArticle"
            class="primary"
            @click="addScanner"
          >
            {{ $t('ScanArticle') }}
          </button>
        </div>
      </div>
      <div
        v-if="loadingScanned"
        style="display:flex;gap:5px"
      >
        <div
          class="spinner-border spinner-border-sm"
        />
        <p style="font-weight:600;">
          {{ $t('AddingScannedProduct') }}
        </p>
      </div>
      <div style="display:flex;gap:5px;align-items:center">
        <p style="color:red;margin-bottom:0px;">
          {{ warningText }}
        </p>
        <div
          v-if="warningText !== ''"
          class="small-button"
        >
          <img
            style="width: 25px;cursor:pointer"
            src="../../../assets/images/plus.svg"
            alt=""
            @click="addArticlesNotInStock"
          >
        </div>
      </div>
      <div
        v-if="articleList.length > 0"
        style="border: 1px solid lightgrey; border-radius: 12px;padding: 10px;margin-top: 10px;"
      >
        <section
          v-for="(articles, index) in articleList"
          :key="index"
          class="custom-modal__wrapper"
          style="margin-bottom: 20px; flex-direction: column"
        >
          <div
            class="paragraphText"
            style="justify-content: space-between;"
          >
            <h3 v-if="articles.typeOfArticle !== 'Custom article'">
              {{ articles.articleNumber }}
            </h3>
            <b-form-group
              v-else
              :label="$t('CustomArticleNumber')"
            >
              <p
                v-if="articles.textFromScanner !== ''"
                style="color:red;"
              >
                {{ articles.textFromScanner }}
              </p>
              <b-form-input
                v-model="articles.orderedArticleNumber"
                type="text"
                :placeholder="$t('ArticleNumber')"
                style="width: 100%"
              />
              <p
                v-if="!articles.orderedArticleNumber"
                style="color:red;"
              >
                {{ $t('WriteArticleNumber') }}
              </p>
            </b-form-group>
            <div style="display:flex; gap:10px;">
              <b-icon-x-circle
                style="cursor:pointer;"
                @click="removeArticle(index)"
              />
              <b-icon-chevron-down
                v-if="!articles.isCollapsed"
                style="cursor:pointer; margin-left: 10px;"
                @click="toggleCollapse(index)"
              />
              <b-icon-chevron-up
                v-if="articles.isCollapsed"
                style="cursor:pointer; margin-left: 10px;"
                @click="toggleCollapse(index)"
              />
            </div>
          </div>
          <p
            v-if="articles.descriptionArticleNotStock"
            style="font-weight:600"
          >
            {{ $t('IfArticleNotStock') }}
          </p>
          <b-collapse
            :id="'collapse-' + index"
            :visible="articles.isCollapsed"
            class="mt-2"
          >
            <div class="newTable">
              <div
                v-if="articles.measurementType === 'Meter'"
                class="display-prices"
              >
                <b-form-group
                  :label="$t('Quantity')"
                >
                  <b-form-input
                    v-model.number="articles.quantityMeter"
                    type="number"
                    :placeholder="$t('Amount')"
                    @input="calculateFromAmount(articles)"
                  />
                </b-form-group>
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('MeasurementType')"
                >
                  <vue-select
                    v-model="articles.measurementType"
                    :options="measurementTypes"
                    :clearable="false"
                    label="name"
                    :reduce="(e) => e.value"
                    style="width:100%"
                    @input="checkIfMeter(articles)"
                  />
                </b-form-group>
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('Quantity')"
                >
                  <b-form-input
                    v-model.number="articles.quantity"
                    type="number"
                    :placeholder="$t('Amount')"
                    @input="calculateFromAmount(articles)"
                  />
                  <p
                    v-if="articles.validationamount == true && buttonSubmited"
                    style="color:lightcoral"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('PriceNoVat')"
                >
                  <b-form-input
                    v-model.number="articles.priceWithoutVAT"
                    type="number"
                    :placeholder="$t('Value')"
                    :disabled="articles.quantity == 0 || articles.quantity == '' || articles.quantity == null"
                    @input="calculateFromPriceWithoutVAT(articles)"
                  />
                  <p
                    v-if="articles.validationPriceWithoutVAT == true && buttonSubmited"
                    style="color:lightcoral"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('PriceWithVat')"
                >
                  <b-form-input
                    v-model.number="articles.priceWithVAT"
                    type="number"
                    :placeholder="$t('Value')"
                    :disabled="articles.quantity == 0 || articles.quantity == '' || articles.quantity == null"
                    @input="calculateFromPriceWithVAT(articles)"
                  />
                  <p
                    v-if="articles.validationPriceWithVAT == true && buttonSubmited"
                    style="color:lightcoral"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('Vat')"
                >
                  <b-form-select
                    v-model="articles.selectedVAT"
                    dropup
                    required
                    :options="vatOptions"
                    @input="updateAllVAT(articles, articles.selectedVAT)"
                  />
                </b-form-group>
              </div>
            </div>
            <div class="newTable">
              <div class="display-prices">
                <b-form-group
                  :label="$t('Discount')"
                >
                  <b-input
                    v-model.number="articles.discount"
                    type="number"
                    default="0"
                    :disabled="articles.priceWithVAT == 0 || articles.priceWithVAT == ''"
                  />
                </b-form-group>
                <b-form-select
                  v-model="articles.discountType"
                >
                  <option value="$">
                    $
                  </option>
                  <option value="€">
                    €
                  </option>
                  <option value="CHF">
                    CHF
                  </option>
                  <option value="%">
                    %
                  </option>
                </b-form-select>
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('DiscountedPrice')"
                >
                  <b-input
                    v-model.number="articles.discountedPrice"
                    disabled
                    type="number"
                  />
                </b-form-group>
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('AmountWithoutVat')"
                >
                  <b-form-input
                    v-model.number="articles.valueWithoutVAT"
                    type="number"
                    :placeholder="$t('Value')"
                    disabled
                  />
                  <p
                    v-if="articles.validationValueWithVAT == true && buttonSubmited"
                    style="color:lightcoral"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('AmountWithVat')"
                >
                  <b-form-input
                    v-model.number="articles.valueWithVAT"
                    type="number"
                    :placeholder="$t('Value')"
                    disabled
                  />
                  <p
                    v-if="articles.validationValueWithVAT == true && buttonSubmited"
                    style="color:lightcoral"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
              </div>
            </div>
            <!-- <div
                class="tt"
                style="padding-top: 16px"
              >
                <table
                  class="team_table"
                >
                  <thead>
                    <tr>
                      <th v-if="articles.measurementType === 'Meter'">
                        {{ $t('Quantity') }}
                      </th>
                      <th>
                        <vue-select
                          v-model="articles.measurementType"
                          :options="measurementTypes"
                          :clearable="false"
                          label="name"
                          :reduce="(e) => e.value"
                          style="width:100%"
                          @input="checkIfMeter(articles)"
                        />
                      </th>
                      <th>{{ $t('PriceNoVat') }}</th>
                      <th>{{ $t('Vat') }}</th>
                      <th>{{ $t('PriceWithVat') }}</th>
                      <th>{{ $t('Discount') }}</th>
                      <th>{{ $t('DiscountedPrice') }}</th>
                      <th>{{ $t('AmountWithoutVat') }}</th>
                      <th>{{ $t('AmountWithVat') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-if="articles.measurementType === 'Meter'">
                        <b-form-input
                          v-model.number="articles.quantityMeter"
                          type="number"
                          :placeholder="$t('Amount')"
                          @input="calculateFromAmount(articles)"
                        />
                      </td>
                      <td>
                        <b-form-input
                          v-model.number="articles.quantity"
                          type="number"
                          :placeholder="$t('Amount')"
                          @input="calculateFromAmount(articles)"
                        />
                        <p
                          v-if="articles.validationamount == true"
                          style="color:lightcoral"
                        >
                          {{ $t('TheValue') }}
                        </p>
                      </td>
                      <td>
                        <b-form-input
                          v-model.number="articles.priceWithoutVAT"
                          type="number"
                          :placeholder="$t('Value')"
                          :disabled="articles.quantity == 0 || articles.quantity == '' || articles.quantity == null"
                          @input="calculateFromPriceWithoutVAT(articles)"
                        />
                        <p
                          v-if="articles.validationPriceWithoutVAT == true"
                          style="color:lightcoral"
                        >
                          {{ $t('TheValue') }}
                        </p>
                      </td>
                      <td>
                        <b-form-radio-group
                          v-model="articles.selectedVAT"
                          :options="vatOptions"
                          style="display:flex;gap: 5px;align-items: center;"
                          @input="updateAllVAT(articles, articles.selectedVAT)"
                        />
                      </td>
                      <td>
                        <b-form-input
                          v-model.number="articles.priceWithVAT"
                          type="number"
                          :placeholder="$t('Value')"
                          :disabled="articles.quantity == 0 || articles.quantity == '' || articles.quantity == null"
                          @input="calculateFromPriceWithVAT(articles)"
                        />
                        <p
                          v-if="articles.validationPriceWithVAT == true"
                          style="color:lightcoral"
                        >
                          {{ $t('TheValue') }}
                        </p>
                      </td>
                      <td>
                        <div style="display:flex;margin-right: 5px;">
                          <b-input
                            v-model.number="articles.discount"
                            type="number"
                            default="0"
                            :disabled="articles.priceWithVAT == 0 || articles.priceWithVAT == ''"
                          />
                          <b-form-select
                            v-model="articles.discountType"
                            style="height:38px; border-radius: 0.25rem; border: 1px solid #EAECF0"
                          >
                            <option value="$">
                              $
                            </option>
                            <option value="€">
                              €
                            </option>
                            <option value="CHF">
                              CHF
                            </option>
                            <option value="%">
                              %
                            </option>
                          </b-form-select>
                        </div>
                      </td>
                      <td>
                        <div style="display:flex">
                          <b-input
                            v-model.number="articles.discountedPrice"
                            disabled
                            type="number"
                            style="width: 90%;"
                          />
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          v-model.number="articles.valueWithoutVAT"
                          type="number"
                          :placeholder="$t('Value')"
                          disabled
                        />
                        <p
                          v-if="articles.validationValueWithVAT == true"
                          style="color:lightcoral"
                        >
                          {{ $t('TheValue') }}
                        </p>
                      </td>
                        class="primary"
                        class="primary"
                      <td>
                        <b-form-input
                          v-model.number="articles.valueWithVAT"
                          type="number"
                          :placeholder="$t('Value')"
                          disabled
                        />
                        <p
                          v-if="articles.validationValueWithVAT == true"
                          style="color:lightcoral"
                        >
                          {{ $t('TheValue') }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->

            <div
              class="formInput"
              style="align-items: baseline;"
            >
              <b-form-group
                :label="$t('PickupDate')"
              >
                <date-picker
                  v-model="articles.pickedUpDate"
                  format="YYYY-MM-DD"
                  value-type="format"
                  :clearable="false"
                  :placeholder="$t('PickUpDate')"
                />
              </b-form-group>
            </div>
          </b-collapse>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
// import { StreamBarcodeReader } from 'vue-barcode-reader';
import { BrowserMultiFormatReader } from '@zxing/library';

export default {
  components: {
    DatePicker,
    // StreamBarcodeReader,
  },
  props: ['articleList', 'filiale', 'buttonSubmited'],
  data() {
    return {
      searchFilterOptions: [
        {
          text: this.$t('ArticleNumber'),
          value: 'ArticleNumber',
        },
        {
          text: this.$t('Barcode'),
          value: 'Barcode',
        },
      ],
      notInStockObject: {},
      measurementTypes: [
        { name: this.$t('Meter'), value: 'Meter' },
        { name: this.$t('Part'), value: 'Part' },
      ],
      responseText: '',
      loadingScanned: false,
      isScanning: true,
      scanArticle: false,
      currencies: ['€', '$', '%'],
      toggleSearch: 'ArticleNumber',
      searchArticle: '',
      searchCode: '',
      searchBarcode: '',
      arrowCounter: 0,
      arrowCounter1: 0,
      enterPressed: false,
      skipWatch: false,
      warningText: '',
      pageNumberFilter: 1,
      pageSizeFilter: 5,
      vatOptions: [
        { text: '18%', value: 18 },
        { text: '8%', value: 8 },
        { text: '0%', value: 0 },
      ],
      codeReader: null,
      videoStream: null,
    };
  },
  computed: {
    ...mapGetters(['getArticleNameLike',
      'getMaterials',
      'getIsLoading',
      'getCurrentPageForMaterials',
      'getTotalItemsForMaterials',
      'getMatVarCurrentPage',
      'getTotalPriceByMaterialId',
      'getFilteredDresses',
      'getArticleByBarcode',
      'getSupplierDropDown',
      'getAccountDetails',
      'getTotalItemsForMaterials',
      'getCurrentPageForMaterials',
      'getTotalPagesForAll',
      'getLocationsMoving',
      'getSellPriceByBarcode',
      'getPriceForArticle',
    ]),
    searchValue: {
      get() {
        if (this.toggleSearch === 'ArticleNumber') return this.searchArticle;
        if (this.toggleSearch === 'Barcode') return this.searchBarcode;
        return '';
      },
      set(value) {
        if (this.toggleSearch === 'ArticleNumber') this.searchArticle = value;
        else if (this.toggleSearch === 'Barcode') this.searchBarcode = value;
      },
    },
    filteredResults() {
      if (this.toggleSearch === 'ArticleNumber') return this.getArticleNameLike;
      if (this.toggleSearch === 'Barcode') return this.getArticleByBarcode;
      return [];
    },
  },
  watch: {
    articleList: {
      handler(newValue) {
        newValue.forEach((article, index) => {
          this.resetQuantityIfNegative(article);

          if (this.timeoutIds && this.timeoutIds[index]) {
            clearTimeout(this.timeoutIds[index]);
          }
          this.timeoutIds = this.timeoutIds || [];
          this.timeoutIds[index] = setTimeout(() => {
            if (article.quantity > 0) {
              if (article.discountType === '$' || article.discountType === '€' || article.discountType === 'CHF') {
                if (article.discount > article.priceWithVAT) {
                  article.discount = 0;
                }
                article.discountedPrice = (article.priceWithVAT - article.discount).toFixed(2);
              } else if (article.discountType === '%') {
                if (article.discount < 0) {
                  article.discount = 0;
                } else if (article.discount > 100) {
                  article.discount = 100;
                }
                const percentageDiscount = (article.discount / 100) * article.priceWithVAT;
                article.discountedPrice = (article.priceWithVAT - percentageDiscount).toFixed(2);
              }

              if (article.discount === '') {
                article.discount = 0;
              }
              article.valueWithVAT = (article.discountedPrice * article.quantity * article.quantityMeter).toFixed(2);
            }
            if (article.quantityMeter < 0 || article.quantityMeter == '') {
              article.quantityMeter = 0;
            }
          }, 100);
        });
      },
      deep: true,
    },
    searchArticle(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeLists();
        } else if (!this.enterPressed) {
          this.productInStock_articleNumberLike(value);
        }
      }, 500);
      this.warningText = ''
    },
    searchCode(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeLists();
        } else if (!this.enterPressed) {
          this.filteredDressesByName({
            code: value,
            name: null,
          });
        }
      }, 500);
      this.warningText = ''
    },
    searchBarcode(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeLists();
        } else if (!this.enterPressed) {
          this.loadArticleByBarcode({
            barcodeLike: value,
          });
        }
      }, 500);
      this.warningText = ''
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions(['totalPriceByMaterialId',
      'resetMaterialVariant',
      'variantsByDropdownName',
      'addMaterial',
      'loadMaterials',
      'editMaterialReq',
      'loadMaterialVariant',
      'addMaterialVariant',
      'changeLoadingtoTrue',
      'resetVariantsName',
      'resetProductInStock',
      'variantsByDropdownCode',
      'resetFilteredDresses',
      'resetLoadBarcode',
      'loadArticleByBarcode',
      'receiveVariantsAndPurchase',
      'loadSuppliers',
      'productInStock_articleNumberLike',
      'filteredDressesByName',
      'loadColors',
      'loadPriceByBarcode',
      'locationPagination',
      'loadPriceForArticle',
      'loadItemsByBarcodeScanner',
    ]),
    displayResult(result) {
      if (this.toggleSearch === 'Barcode') return `${result.articleNumber} - ${result.barcode}`;
      return result.articleNumber;
    },
    selectResult(result) {
      if (this.toggleSearch === 'ArticleNumber') this.searchByOn(result);
      else if (this.toggleSearch === 'Barcode') this.searchByBarcode(result);
    },
    arrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.filteredResults.length - 1) {
        this.arrowCounter++;
        this.fixScrolling();
      }
    },
    arrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter--;
        this.fixScrolling();
      }
    },
    selectHighlighted() {
      if (this.arrowCounter >= 0 && this.filteredResults.length > 0) {
        this.selectResult(this.filteredResults[this.arrowCounter]);
      }
    },
    fixScrolling() {
      this.$nextTick(() => {
        const options = this.$refs.options;
        const scrollContainer = this.$refs.scrollContainer?.$el;

        if (!options || !options[this.arrowCounter] || !scrollContainer) return;
        const selectedOption = options[this.arrowCounter];
        const optionHeight = selectedOption.clientHeight;

        const containerRect = scrollContainer.getBoundingClientRect();
        const selectedRect = selectedOption.getBoundingClientRect();

        if (selectedRect.bottom > containerRect.bottom) {
          scrollContainer.scrollTop += optionHeight;
        } else if (selectedRect.top < containerRect.top) {
          scrollContainer.scrollTop -= optionHeight;
        }
      });
    },
    updateAllVAT(articles, value) {
      this.articleList.forEach((material) => {
        material.selectedVAT = value;
        this.calculateFromSelectedVAT(articles);
      });
    },
    checkIfMeter(articles) {
      if (articles.measurementType === 'Meter') {
        articles.ifMeasurementTypeMeter = true;
      } else {
        articles.ifMeasurementTypeMeter = false;
        articles.quantityMeter = 1
      }
    },
    addArticlesNotInStock() {
      const vatNumber = this.articleList.length == 0 ? 18 : this.articleList[0].selectedVAT
      this.articleList.push({
        orderedArticleNumber: null,
        articleNumber: `${this.notInStockObject.articleName} - ${this.$t('NotInStock')}`,
        inventoryProductId: null,
        locationId: null,
        locationName: null,
        productInStockId: null,
        sellPrice: 0,
        discount: 0,
        currency: '€',
        sellPriceWithDiscount: 0,
        fileUrl: null,
        typeOfArticle: 'Catalog article',
        pickedUpDate: moment().format('YYYY-MM-DD'),
        orderedProductId: this.notInStockObject.inventoryProductId,
        valueWithVAT: (this.notInStockObject.price || 0),
        valueWithoutVAT: parseFloat((((this.notInStockObject.price || 0) / (1 + vatNumber / 100)) * 1).toFixed(2)),
        quantity: 1,
        priceWithVAT: (this.notInStockObject.price || 0),
        priceWithoutVAT: parseFloat(((this.notInStockObject.price || 0) / (1 + vatNumber / 100)).toFixed(2)),
        selectedVAT: this.articleList.length == 0 ? 18 : this.articleList[0].selectedVAT,
        validationPriceWithoutVAT: false,
        validationamount: false,
        validationPriceWithVAT: false,
        validationValueWithVAT: false,
        discountedPrice: (this.notInStockObject.price || 0),
        discountType: '€',
        isCollapsed: true,
        textFromScanner: '',
        descriptionArticleNotStock: true,
        measurementType: 'Part',
        ifMeasurementTypeMeter: false,
        quantityMeter: 1,
      })
      this.notInStockObject = {};
      this.warningText = '';
    },
    addScanner() {
      this.scanArticle = true
      this.isScanning = false;
      this.warningText = ''
      this.startScanner();
    },
    removeScanner() {
      this.scanArticle = false
      this.isScanning = true;
      this.warningText = ''
      this.stopScanner();
    },
    startScanner() {
      const codeReader = new BrowserMultiFormatReader();
      this.codeReader = codeReader;
      const videoElement = this.$refs.video;

      codeReader
        .decodeFromVideoDevice(null, videoElement, (result, err) => {
          if (result) {
            this.onDecode(result.getText());
          }
          if (err && err.name !== 'NotFoundException') {
            console.error(err);
          }
        });

      navigator.mediaDevices
        .getUserMedia({
          video: { facingMode: { exact: 'environment' } },
        })
        .then((stream) => {
          this.videoStream = stream;
          videoElement.srcObject = stream;
        })
        .catch((error) => {
          console.error('Error accessing camera:', error);
        });
    },
    stopScanner() {
      if (this.codeReader) {
        this.codeReader.reset();
      }

      if (this.videoStream) {
        const tracks = this.videoStream.getTracks();
        tracks.forEach((track) => { return track.stop() });
      }
      this.videoStream = null;
    },
    onDecode(text) {
      if (this.isScanning) {
        return;
      }
      this.isScanning = true;

      this.searchByBarcodeScanner(text)
    },
    onLoaded() {
      console.log('Ready to start scanning barcodes')
    },
    async searchByBarcodeScanner(value) {
      this.scanArticle = false;
      this.loadingScanned = true
      this.loadItemsByBarcodeScanner({
        barcode: value,
        storeId: this.filiale.storeId,
      }).then((response) => {
        this.responseText = response
        if (!response || (Object.keys(response).length === 0 && response.constructor === Object)) {
          this.addCustomArticleScanner();
        } else {
          if (response.productInStockId === '00000000-0000-0000-0000-000000000000') {
            this.warningText = `${response.articleName}, ${this.$t('NotInStock')}. ${this.$t('DoYouWantOrder')}`;
            this.resetLoadBarcode();
            this.skipWatch = true;
            this.searchBarcode = '';
            this.scanArticle = false;
            this.loadingScanned = false;
            this.notInStockObject = response
            this.stopScanner();
            return;
          }
          const vatNumber = this.articleList.length == 0 ? 18 : this.articleList[0].selectedVAT
          this.articleList.push({
            orderedArticleNumber: null,
            articleNumber: `${response.articleName} - ${value}`,
            inventoryProductId: response.inventoryProductId,
            locationId: null,
            locationName: null,
            productInStockId: response.productInStockId,
            sellPrice: 0,
            discount: 0,
            currency: '€',
            sellPriceWithDiscount: 0,
            fileUrl: null,
            typeOfArticle: 'Catalog article',
            pickedUpDate: moment().format('YYYY-MM-DD'),
            orderedProductId: null,
            valueWithVAT: response.price,
            valueWithoutVAT: parseFloat((((response.price) / (1 + vatNumber / 100)) * 1).toFixed(2)),
            quantity: 1,
            priceWithVAT: response.price,
            priceWithoutVAT: parseFloat(((response.price) / (1 + vatNumber / 100)).toFixed(2)),
            selectedVAT: this.articleList.length == 0 ? 18 : this.articleList[0].selectedVAT,
            validationPriceWithoutVAT: false,
            validationamount: false,
            validationPriceWithVAT: false,
            validationValueWithVAT: false,
            discountedPrice: response.price,
            discountType: '€',
            isCollapsed: true,
            textFromScanner: '',
            measurementType: 'Part',
            descriptionArticleNotStock: false,
            ifMeasurementTypeMeter: false,
            quantityMeter: 1,
          });
          this.skipWatch = true;
          this.searchBarcode = '';
          this.scanArticle = false;
          this.loadingScanned = false
          this.stopScanner();
          this.resetLoadBarcode();
        }
      }).catch((error) => {
        console.error('Error scanning barcode:', error);
      });
    },
    addCustomArticleScanner() {
      this.articleList.push({
        orderedArticleNumber: null,
        articleNumber: null,
        inventoryProductId: null,
        locationId: null,
        locationName: null,
        productInStockId: null,
        sellPrice: 0,
        discount: 0,
        currency: '€',
        sellPriceWithDiscount: 0,
        fileUrl: null,
        typeOfArticle: 'Custom article',
        pickedUpDate: moment().format('YYYY-MM-DD'),
        orderedProductId: null,
        valueWithVAT: 0,
        valueWithoutVAT: 0,
        quantity: 0,
        priceWithVAT: 0,
        priceWithoutVAT: 0,
        selectedVAT: this.articleList.length == 0 ? 18 : this.articleList[0].selectedVAT,
        validationPriceWithoutVAT: true,
        validationamount: true,
        validationPriceWithVAT: true,
        validationValueWithVAT: true,
        discountedPrice: 0,
        discountType: '€',
        isCollapsed: true,
        textFromScanner: `${this.$t('ThisProductNotRegistered')}`,
        measurementType: 'Part',
        descriptionArticleNotStock: true,
        ifMeasurementTypeMeter: false,
        quantityMeter: 1,
      });
      this.scanArticle = false;
      this.loadingScanned = false
      this.stopScanner();
    },
    toggleCollapse(index) {
      this.articleList[index].isCollapsed = !this.articleList[index].isCollapsed;
    },
    validateMaterials() {
      this.articleList.forEach((material) => {
        if (material.valueWithVAT <= 0 || material.valueWithVAT === null || material.valueWithVAT === '') {
          material.validationValueWithVAT = true;
        } else {
          material.validationValueWithVAT = false;
        }

        if (material.quantity <= 0 || material.quantity === null || material.quantity === '') {
          material.validationamount = true;
        } else {
          material.validationamount = false;
        }

        if (material.priceWithoutVAT <= 0 || material.priceWithoutVAT === null || material.priceWithoutVAT === '') {
          material.validationPriceWithoutVAT = true;
        } else {
          material.validationPriceWithoutVAT = false;
        }

        if (material.priceWithVAT <= 0 || material.priceWithVAT === null || material.priceWithVAT === '') {
          material.validationPriceWithVAT = true;
        } else {
          material.validationPriceWithVAT = false;
        }
      });
    },
    calculateFromAmount(material) {
      if (material.quantity > 0) {
        material.priceWithVAT = parseFloat((material.priceWithoutVAT * (1 + material.selectedVAT / 100)).toFixed(2));
        material.valueWithVAT = parseFloat((material.priceWithVAT * material.quantity * material.quantityMeter).toFixed(2));
        material.valueWithoutVAT = parseFloat((material.priceWithoutVAT * material.quantity * material.quantityMeter).toFixed(2));
      }
      this.validateMaterials()
    },
    calculateFromPriceWithVAT(material) {
      if (material.quantity > 0) {
        material.priceWithoutVAT = parseFloat((material.priceWithVAT / (1 + material.selectedVAT / 100)).toFixed(2));
        material.valueWithVAT = parseFloat((material.priceWithVAT * material.quantity * material.quantityMeter).toFixed(2));
        material.valueWithoutVAT = parseFloat((material.priceWithoutVAT * material.quantity * material.quantityMeter).toFixed(2));
      } else {
        material.priceWithoutVAT = parseFloat((material.priceWithVAT / (1 + material.selectedVAT / 100)).toFixed(2));
      }
      this.validateMaterials()
    },
    calculateFromSelectedVAT(material) {
      if (material.quantity > 0) {
        material.priceWithVAT = parseFloat((material.priceWithoutVAT * (1 + material.selectedVAT / 100)).toFixed(2));
        material.valueWithVAT = parseFloat((material.priceWithVAT * material.quantity * material.quantityMeter).toFixed(2));
        material.valueWithoutVAT = parseFloat((material.priceWithoutVAT * material.quantity * material.quantityMeter).toFixed(2));
      } else if (material.priceWithoutVAT > 0) {
        material.priceWithVAT = parseFloat((material.priceWithoutVAT * (1 + material.selectedVAT / 100)).toFixed(2));
      }

      if (material.priceWithVAT > 0) {
        material.priceWithoutVAT = parseFloat((material.priceWithVAT / (1 + material.selectedVAT / 100)).toFixed(2));
      }
      this.validateMaterials()
    },
    calculateFromPriceWithoutVAT(material) {
      if (material.quantity > 0) {
        material.priceWithVAT = parseFloat((material.priceWithoutVAT * (1 + material.selectedVAT / 100)).toFixed(2));
        material.valueWithVAT = parseFloat((material.priceWithVAT * material.quantity * material.quantityMeter).toFixed(2));
        material.valueWithoutVAT = parseFloat((material.priceWithoutVAT * material.quantity * material.quantityMeter).toFixed(2));
      } else {
        material.priceWithVAT = parseFloat((material.priceWithoutVAT * (1 + material.selectedVAT / 100)).toFixed(2));
      }
      this.validateMaterials()
    },
    calculateFromValueWithVAT(material) {
      if (material.quantity > 0) {
        material.priceWithVAT = parseFloat((material.valueWithVAT / material.quantity).toFixed(2));
        material.priceWithoutVAT = parseFloat((material.priceWithVAT / (1 + material.selectedVAT / 100)).toFixed(2));
      }
      this.validateMaterials()
    },
    removeArticle(index) {
      this.articleList.splice(index, 1);
    },
    toggleName(value) {
      this.toggleSearch = value;
      this.searchArticle = '';
      this.searchCode = '';
      this.searchBarcode = '';
      this.removeLists();
    },
    async searchByOn(value) {
      this.loadPriceForArticle({
        inventoryProductId: value.inventoryId,
        storeId: this.filiale.storeId,
      }).then((response) => {
        if (response.productInStockId === '00000000-0000-0000-0000-000000000000') {
          this.warningText = `${response.articleName}, ${this.$t('NotInStock')}. ${this.$t('DoYouWantOrder')}`;
          this.skipWatch = true;
          this.searchArticle = '';
          this.resetProductInStock();
          this.scanArticle = false;
          this.loadingScanned = false;
          this.notInStockObject = response
          this.stopScanner();
          return;
        }
        const vatNumber = this.articleList.length == 0 ? 18 : this.articleList[0].selectedVAT
        this.articleList.push({
          orderedArticleNumber: null,
          articleNumber: `${value.articleNumber}`,
          inventoryProductId: response.inventoryProductId,
          locationId: null,
          locationName: null,
          productInStockId: response.productInStockId,
          sellPrice: 0,
          discount: 0,
          currency: '€',
          sellPriceWithDiscount: 0,
          fileUrl: null,
          typeOfArticle: 'Catalog article',
          pickedUpDate: moment().format('YYYY-MM-DD'),
          orderedProductId: null,
          valueWithVAT: (response.price || 0),
          valueWithoutVAT: parseFloat((((response.price || 0) / (1 + vatNumber / 100)) * 1).toFixed(2)),
          quantity: 1,
          priceWithVAT: (response.price || 0),
          priceWithoutVAT: parseFloat(((response.price || 0) / (1 + vatNumber / 100)).toFixed(2)),
          selectedVAT: this.articleList.length == 0 ? 18 : this.articleList[0].selectedVAT,
          validationPriceWithoutVAT: false,
          validationamount: false,
          validationPriceWithVAT: false,
          validationValueWithVAT: false,
          discountedPrice: (response.price || 0),
          discountType: '€',
          isCollapsed: true,
          textFromScanner: '',
          measurementType: 'Part',
          descriptionArticleNotStock: false,
          ifMeasurementTypeMeter: false,
          quantityMeter: 1,
        });
        this.skipWatch = true;
        this.searchArticle = '';
        this.resetProductInStock();
      });
    },
    async searchByBarcode(value) {
      this.loadItemsByBarcodeScanner({
        barcode: value.barcode,
        storeId: this.filiale.storeId,
      }).then((response) => {
        console.log('response', response)
        if (response.productInStockId === '00000000-0000-0000-0000-000000000000') {
          this.warningText = `${response.articleName}, ${this.$t('NotInStock')}. ${this.$t('DoYouWantOrder')}`;
          this.resetLoadBarcode();
          this.skipWatch = true;
          this.searchBarcode = '';
          this.scanArticle = false;
          this.loadingScanned = false;
          this.notInStockObject = response
          this.stopScanner();
          return;
        }
        const vatNumber = this.articleList.length == 0 ? 18 : this.articleList[0].selectedVAT
        this.articleList.push({
          orderedArticleNumber: null,
          articleNumber: `${value.articleNumber}`,
          inventoryProductId: response.inventoryProductId,
          locationId: null,
          locationName: null,
          productInStockId: response.productInStockId,
          sellPrice: 0,
          discount: 0,
          currency: '€',
          sellPriceWithDiscount: 0,
          fileUrl: null,
          typeOfArticle: 'Catalog article',
          pickedUpDate: moment().format('YYYY-MM-DD'),
          orderedProductId: null,
          valueWithVAT: (response.price || 0),
          valueWithoutVAT: parseFloat((((response.price || 0) / (1 + vatNumber / 100)) * 1).toFixed(2)),
          quantity: 1,
          priceWithVAT: (response.price || 0),
          priceWithoutVAT: parseFloat(((response.price || 0) / (1 + vatNumber / 100)).toFixed(2)),
          selectedVAT: this.articleList.length == 0 ? 18 : this.articleList[0].selectedVAT,
          validationPriceWithoutVAT: false,
          validationamount: false,
          validationPriceWithVAT: false,
          validationValueWithVAT: false,
          discountedPrice: (response.price || 0),
          discountType: '€',
          isCollapsed: true,
          textFromScanner: '',
          measurementType: 'Part',
          descriptionArticleNotStock: false,
          ifMeasurementTypeMeter: false,
          quantityMeter: 1,
        });
        this.skipWatch = true;
        this.searchBarcode = '';
        this.resetLoadBarcode();
      });
    },
    onArrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getArticleNameLike.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOn(this.getArticleNameLike[this.arrowCounter])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    onArrowDown1(ev) {
      ev.preventDefault()
      if (this.arrowCounter1 < this.getFilteredDresses.length - 1) {
        this.arrowCounter1 += 1;
        this.fixScrolling();
      }
    },
    onArrowUp1(ev) {
      ev.preventDefault()
      if (this.arrowCounter1 > 0) {
        this.arrowCounter1 -= 1;
        this.fixScrolling()
      }
    },
    inputChanged1(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByCode(this.getFilteredDresses[this.arrowCounter1])
        this.removeLists()
        this.arrowCounter1 = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    onArrowDownBarcode(ev) {
      ev.preventDefault()
      if (this.arrowCounter1 < this.getArticleByBarcode.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUpBarcode(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    inputChangedBarcode(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByBarcode(this.getArticleByBarcode[this.arrowCounter1])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    removeLists() {
      this.resetProductInStock()
      this.resetFilteredDresses();
      this.resetLoadBarcode()
    },
    addCustomArticle() {
      this.articleList.push({
        orderedArticleNumber: null,
        articleNumber: null,
        inventoryProductId: null,
        locationId: null,
        locationName: null,
        productInStockId: null,
        sellPrice: 0,
        discount: 0,
        currency: '€',
        sellPriceWithDiscount: 0,
        fileUrl: null,
        typeOfArticle: 'Custom article',
        pickedUpDate: moment().format('YYYY-MM-DD'),
        orderedProductId: null,
        valueWithVAT: 0,
        valueWithoutVAT: 0,
        quantity: 0,
        priceWithVAT: 0,
        priceWithoutVAT: 0,
        selectedVAT: this.articleList.length == 0 ? 18 : this.articleList[0].selectedVAT,
        validationPriceWithoutVAT: true,
        validationamount: true,
        validationPriceWithVAT: true,
        validationValueWithVAT: true,
        discountedPrice: 0,
        discountType: '€',
        isCollapsed: true,
        textFromScanner: '',
        measurementType: 'Part',
        descriptionArticleNotStock: true,
        ifMeasurementTypeMeter: false,
        quantityMeter: 1,
      });
    },

    resetQuantityIfNegative(article) {
      if (article.quantity < 0 || article.quantity == '') {
        article.quantity = 0;
        article.valueWithVAT = 0;
        article.validationValueWithVAT = true;
      }
    },
  },
};
</script>

    <style>
  .button3 {
    background: #FF274F !important;
    font-weight: 500;
    font-size: 15px !important;
    color: white;
    border-radius: 6px;
    height: 38px;
    width: 250px;
    border: none;
    padding: 6px;
  }

  .button3:hover {
    border: 1px solid #FF274F !important;
    background: white !important;
    color: #FF274F !important;
    transition: ease-in-out 0.3s;
    height: 38px;
    width: 250px;
  }
    .active2{
    color: #212529;
    font-weight: bold;
  }
    .dropdrop {
    display: inline-block;
    overflow: auto;
    position: absolute;
    background: white;
    width: 227px;
    box-shadow: none;
    z-index:3;
  }

  input[name="search-box"] {
    display: block;
    max-width: 500px;
    width: 95%;
    padding: 0.5rem 1rem;
    padding-left: 25px;
  }

  .search-item {
    padding: 5px;
    max-width: 500px;
    width: 100%;
    font-weight: 400;
    color: #82868c;
    font-size: 1rem;
    border-bottom: 1px solid #e8e8e8;
  }

  .search-item:last-child {
    border-bottom: none;
  }

  .search-item:hover {
    background: #82868c;
    color: white;
  }

  .search-item hr {
    color: lightgray;
    border-top: none;
    margin: -1.3rem 0 0.5rem 0;
  }

  .is-active {
    background-color: #dedede;
  }
    .custom-modal__wrapper {
      display: flex;
      justify-content: space-between;
      border: 1px solid lightgray;
      border-radius: 10px;
      padding: 10px;
      margin-top: 10px;
    }
    .paragraphText {
      display: flex;
      gap: 10px;
      align-items: flex-start;
      margin-bottom: 10px;
    }
    .paragraphText h3 {
      color: red;
      width: auto;
      background-color: red;
      color: white;
      font-size: 20px;
      padding: 10px;
      border-radius: 12px;
      margin: 0px;
    }
    .formInput {
      display: flex;
      gap: 10px;
      padding-top: 10px;;
    }
    .currencyStyle {
      display: block;
      padding: 0.469rem 0.75rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #212529;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    </style>
